import { i18n } from "@/config/i18n";

export default {
  name: 'Strategies',
  data() {
    return {
      activeFaq: null,
      strategies: [
        {
          labelKey: 'home.strategy1Label',
          titleKey: 'home.strategy1Title',
          descKey:  'home.strategy1Desc',
          returnRange: '8–12%',
          drawdown: '-8%',
          winRate: '68%',
          sharpe: '1,85',
          riskLevel: 2,
          riskLabelKey: 'home.riskLow',
          featured: false,
          details: [
            i18n.global.t('strategies.c_detail1'),
            i18n.global.t('strategies.c_detail2'),
            i18n.global.t('strategies.c_detail3'),
          ],
        },
        {
          labelKey: 'home.strategy2Label',
          titleKey: 'home.strategy2Title',
          descKey:  'home.strategy2Desc',
          returnRange: '30–36%',
          drawdown: '-15%',
          winRate: '72%',
          sharpe: '2,14',
          riskLevel: 3,
          riskLabelKey: 'home.riskMedium',
          featured: true,
          details: [
            i18n.global.t('strategies.b_detail1'),
            i18n.global.t('strategies.b_detail2'),
            i18n.global.t('strategies.b_detail3'),
          ],
        },
        {
          labelKey: 'home.strategy3Label',
          titleKey: 'home.strategy3Title',
          descKey:  'home.strategy3Desc',
          returnRange: '36–45%',
          drawdown: '-25%',
          winRate: '65%',
          sharpe: '1,52',
          riskLevel: 4,
          riskLabelKey: 'home.riskHigh',
          featured: false,
          details: [
            i18n.global.t('strategies.g_detail1'),
            i18n.global.t('strategies.g_detail2'),
            i18n.global.t('strategies.g_detail3'),
          ],
        },
      ],
      compareRows: [
        { labelKey: 'home.metricReturn',          cKey: 'strategies.compareC1', bKey: 'strategies.compareB1', gKey: 'strategies.compareG1' },
        { labelKey: 'home.metricDrawdown',        cKey: 'strategies.compareC2', bKey: 'strategies.compareB2', gKey: 'strategies.compareG2' },
        { labelKey: 'home.metricWinRate',         cKey: 'strategies.compareC3', bKey: 'strategies.compareB3', gKey: 'strategies.compareG3' },
        { labelKey: 'home.metricSharpe',          cKey: 'strategies.compareC4', bKey: 'strategies.compareB4', gKey: 'strategies.compareG4' },
        { labelKey: 'strategies.compareRisk',     cKey: 'strategies.compareC5', bKey: 'strategies.compareB5', gKey: 'strategies.compareG5' },
        { labelKey: 'strategies.compareSuitable', cKey: 'strategies.compareC6', bKey: 'strategies.compareB6', gKey: 'strategies.compareG6' },
      ],
      faqs: [
        { q: 'home.faq1Q', a: 'home.faq1A' },
        { q: 'home.faq2Q', a: 'home.faq2A' },
        { q: 'home.faq3Q', a: 'home.faq3A' },
        { q: 'home.faq4Q', a: 'home.faq4A' },
        { q: 'home.faq5Q', a: 'home.faq5A' },
      ],
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  },
  methods: {
    t(key) { return i18n.global.t(key); },
    toggleFaq(i) { this.activeFaq = this.activeFaq === i ? null : i; },
    goToContact() { this.$router.push('/contact'); },
  },
};
